export const QUOTE_SOURCE_CONTEXT_STORAGE_KEY = 'quoteSourceContext';

/** Discard quote context after 15 minutes. */
const QUOTE_SOURCE_CONTEXT_TTL_MS = 15 * 60 * 1000;

const ALLOWED_QUOTE_SOURCES = new Set(['public_profile', 'offer']);

/** Max chars for targeted-pro display name in quote confirm UI. */
export const QUOTE_TARGET_PRO_NAME_MAX_CHARS = 45;

export function clearQuoteSourceContext() {
  if (typeof window === 'undefined') return;
  sessionStorage.removeItem(QUOTE_SOURCE_CONTEXT_STORAGE_KEY);
}

/**
 * Truncate a professional display name for UI copy.
 * @param {unknown} name
 * @param {number} [maxChars]
 * @returns {string}
 */
export function formatQuoteTargetProName(name, maxChars = QUOTE_TARGET_PRO_NAME_MAX_CHARS) {
  const trimmed = typeof name === 'string' ? name.trim() : '';
  if (!trimmed) return 'هذا المهني';
  if (trimmed.length <= maxChars) return trimmed;
  return `${trimmed.slice(0, Math.max(0, maxChars - 1)).trimEnd()}…`;
}

function storeQuoteSourceContext(quoteSource, proUserId, proDisplayName) {
  if (typeof window === 'undefined') return;

  const normalizedUserId = typeof proUserId === 'string' ? proUserId.trim() : '';
  if (!normalizedUserId || !ALLOWED_QUOTE_SOURCES.has(quoteSource)) return;

  const normalizedName =
    typeof proDisplayName === 'string' && proDisplayName.trim() ? proDisplayName.trim() : '';

  const payload = {
    quote_source: quoteSource,
    desired_pros: [normalizedUserId],
    setAt: Date.now()
  };
  if (normalizedName) {
    payload.desired_pro_name = normalizedName;
  }

  sessionStorage.setItem(QUOTE_SOURCE_CONTEXT_STORAGE_KEY, JSON.stringify(payload));
}

export function setPublicProfileQuoteSource(proUserId, proDisplayName) {
  storeQuoteSourceContext('public_profile', proUserId, proDisplayName);
}

export function setOfferQuoteSource(proUserId, proDisplayName) {
  storeQuoteSourceContext('offer', proUserId, proDisplayName);
}

export function readQuoteSourceContext() {
  if (typeof window === 'undefined') return null;

  try {
    const raw = sessionStorage.getItem(QUOTE_SOURCE_CONTEXT_STORAGE_KEY);
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    const setAt = typeof parsed?.setAt === 'number' ? parsed.setAt : null;

    if (setAt && Date.now() - setAt > QUOTE_SOURCE_CONTEXT_TTL_MS) {
      clearQuoteSourceContext();
      return null;
    }

    if (
      ALLOWED_QUOTE_SOURCES.has(parsed?.quote_source) &&
      Array.isArray(parsed.desired_pros) &&
      parsed.desired_pros.some((id) => typeof id === 'string' && id.trim() !== '')
    ) {
      const desiredProName =
        typeof parsed.desired_pro_name === 'string' && parsed.desired_pro_name.trim()
          ? parsed.desired_pro_name.trim()
          : null;
      return {
        quote_source: parsed.quote_source,
        desired_pros: parsed.desired_pros
          .filter((id) => typeof id === 'string')
          .map((id) => id.trim())
          .filter(Boolean),
        ...(desiredProName ? { desired_pro_name: desiredProName } : {})
      };
    }
  } catch (error) {
    console.warn('quoteSourceContext: Failed to parse stored context', error);
    clearQuoteSourceContext();
  }

  return null;
}
